export default "__VITE_ASSET__DC_Viw_2__"